// Order drives the flow: VALID_STEPS = Object.values(eOnboardingStep), so the
// enum declaration order IS the step order. RET-1386 front-loads the most
// complex step (channel/WAPI connection) to slot 3 — before Lead Agent config —
// so the user gets "your account is connected" early and the flow ends on the
// value moment (leads entering the funnel) via the /pipe redirect on completion.
// The string *values* are stable IDs persisted in localStorage, so reordering
// the declarations needs no data migration.
export enum eOnboardingStep {
  BUSINESS_INFO = 'business-info',
  FUNNEL_SETUP = 'funnel-setup',
  WHATSAPP_CONNECT = 'whatsapp-connect',
  SMART_LEADBOT = 'smart-leadbot',
  TEAM_INVITE = 'team-invite',
}
